import React from 'react';
import {
	LabelContainer,
	StyledLabel,
} from '../../../../../common/ui/picker-trigger/trigger-component-no-operator/main.tsx';
import { useVerticalMode } from '../../../../../controllers/feature-context.tsx';
import { PickerTriggerLayout } from '../../../../../common/ui/picker-trigger-layout/index.tsx';

export const TriggerLabelContainer = ({
	fieldLabel,
	parentValue,
	childValue,
}: {
	fieldLabel: string;
	parentValue?: string;
	childValue?: string;
}): React.JSX.Element => {
	const parentDisplay = parentValue ? `${parentValue}` : '';
	const childDisplay = parentValue && childValue ? ` - ${childValue}` : '';

	const displayValue = `${parentDisplay}${childDisplay}`;
	const verticalMode = useVerticalMode();

	if (verticalMode) {
		return (
			<PickerTriggerLayout label={fieldLabel}>
				{parentValue && childValue ? displayValue : null}
			</PickerTriggerLayout>
		);
	}
	return (
		<LabelContainer data-testid="jql-builder-basic.ui.jql-editor.field.cascade-select-picker.trigger-label-container.label-container">
			{!parentValue && !childValue ? (
				fieldLabel
			) : (
				<>
					<StyledLabel>{fieldLabel}: </StyledLabel>
					{displayValue}
				</>
			)}
		</LabelContainer>
	);
};
